module.exports = __webpack_public_path__ + "img/img7.2441dcdb.svg";